/**
 * @fileoverview gRPC-Web generated client stub for productupdates
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: productupdates/productupdates.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.productupdates = require('./productupdates_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.productupdates.ProductUpdatesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.productupdates.ProductUpdatesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.GetReleaseNotesRequest,
 *   !proto.productupdates.GetReleaseNotesResponse>}
 */
const methodDescriptor_ProductUpdatesService_GetReleaseNotes = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/GetReleaseNotes',
  grpc.web.MethodType.UNARY,
  proto.productupdates.GetReleaseNotesRequest,
  proto.productupdates.GetReleaseNotesResponse,
  /**
   * @param {!proto.productupdates.GetReleaseNotesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.GetReleaseNotesResponse.deserializeBinary
);


/**
 * @param {!proto.productupdates.GetReleaseNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.GetReleaseNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.GetReleaseNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.getReleaseNotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetReleaseNotes',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetReleaseNotes,
      callback);
};


/**
 * @param {!proto.productupdates.GetReleaseNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.GetReleaseNotesResponse>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.getReleaseNotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetReleaseNotes',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetReleaseNotes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.GetComingSoonRequest,
 *   !proto.productupdates.GetComingSoonResponse>}
 */
const methodDescriptor_ProductUpdatesService_GetComingSoon = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/GetComingSoon',
  grpc.web.MethodType.UNARY,
  proto.productupdates.GetComingSoonRequest,
  proto.productupdates.GetComingSoonResponse,
  /**
   * @param {!proto.productupdates.GetComingSoonRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.GetComingSoonResponse.deserializeBinary
);


/**
 * @param {!proto.productupdates.GetComingSoonRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.GetComingSoonResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.GetComingSoonResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.getComingSoon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetComingSoon,
      callback);
};


/**
 * @param {!proto.productupdates.GetComingSoonRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.GetComingSoonResponse>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.getComingSoon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetComingSoon',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetComingSoon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.productupdates.GetAppVersionRequest,
 *   !proto.productupdates.GetAppVersionResponse>}
 */
const methodDescriptor_ProductUpdatesService_GetAppVersion = new grpc.web.MethodDescriptor(
  '/productupdates.ProductUpdatesService/GetAppVersion',
  grpc.web.MethodType.UNARY,
  proto.productupdates.GetAppVersionRequest,
  proto.productupdates.GetAppVersionResponse,
  /**
   * @param {!proto.productupdates.GetAppVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.productupdates.GetAppVersionResponse.deserializeBinary
);


/**
 * @param {!proto.productupdates.GetAppVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.productupdates.GetAppVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.productupdates.GetAppVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.productupdates.ProductUpdatesServiceClient.prototype.getAppVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetAppVersion',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetAppVersion,
      callback);
};


/**
 * @param {!proto.productupdates.GetAppVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.productupdates.GetAppVersionResponse>}
 *     Promise that resolves to the response
 */
proto.productupdates.ProductUpdatesServicePromiseClient.prototype.getAppVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/productupdates.ProductUpdatesService/GetAppVersion',
      request,
      metadata || {},
      methodDescriptor_ProductUpdatesService_GetAppVersion);
};


module.exports = proto.productupdates;

